/**
 * <paex-motion-scope> — shared fade-up reveal driver for PAEX sections without
 * their own component JS (e.g. Grid banner - PE). Observes descendant
 * .paex-motion elements and heading highlights, revealing them on scroll.
 * CSS lives in paex-components.css (incl. the :not(:defined) failsafe).
 */
if (!customElements.get('paex-motion-scope')) {
  customElements.define(
    'paex-motion-scope',
    class PaexMotionScope extends HTMLElement {
      connectedCallback() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add(
                entry.target.classList.contains('paex-motion') ? 'paex-in-view' : 'animate'
              );
              this.observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.querySelectorAll(
          '.paex-motion, .paex-highlight--hand-drawn-circle, .paex-highlight--thick-underline, .paex-highlight--wave-underline'
        ).forEach((el) => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
